const calendlyLinks = {
  georgia: "https://calendly.com/georgia-ptpf",
};

export default calendlyLinks;